<template>
  <BaseDialog :showCondition="show" @closed="closeDialog()">
    <template v-slot:title>
      <p class="primary--text">إضافة مجال فرصة عمل</p>
    </template>
    <template v-slot:body>
      <v-container>
        <v-row justify="center">
          <v-col cols="12">
            <v-form ref="form">
              <v-text-field :rules="[requiredRule]" v-model="name" outlined persistent-placeholder label="مجال فرصة العمل"
                placeholder="أدخل مجال فرصة العمل هنا"></v-text-field>
            </v-form>
          </v-col>
        </v-row>
      </v-container>
    </template>
    <template v-slot:actions>
      <v-btn @click="sendCreateRequest()" class="accent rounded-pill px-10">
        إضافة
      </v-btn>
    </template>
  </BaseDialog>
</template>

<script>
import { mapActions } from "pinia";
import { useJobFieldStore } from "../../store/JobFieldStore";

import FormValidationRulesMixin from "@/core/mixins/FormValidationRulesMixin.vue";

export default {
  mixins: [FormValidationRulesMixin],
  props: {
    showCondition: Boolean,
  },
  watch: {
    showCondition: {
      immediate: true,
      handler() {
        this.show = this.showCondition;
      },
    },
  },
  data() {
    return {
      show: this.showCondition,
      name: "",
    };
  },
  methods: {
    closeDialog() {
      this.show = false;
      this.$emit("closed");
      this.$refs.form.reset();
    },
    ...mapActions(useJobFieldStore, ["createJobField"]),
    sendCreateRequest() {
      if (this.$refs.form.validate()) {
        var data = { name: this.name };
        this.createJobField(data);
        this.closeDialog();
      }
    },
  },
};
</script>
